import { useState } from 'react';

import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import styled from '@mui/material/styles/styled';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import BillingInfoModal from './BillingInfoModal';
import { sentenceCase } from '../../../../utils/utils';
import Text from '../../../elements/text/Text';
import Title from '../../../elements/title/Title';
import NoContent from '../../../sections/no-content/NoContent';

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2),
  float: 'right',
}));

const BillingInfo = ({ billingInfo, handleConfirm }) => {
  const { t } = useTranslation();

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const keyValuePairs = [
    { name: t('companyName', { ns: 'fields' }), val: 'payerCompany' },
    { name: t('departmentName', { ns: 'fields' }), val: 'payerSection' },
    { name: t('billingContact', { ns: 'fields' }), val: 'payerName' },
    { name: t('email', { ns: 'fields' }), val: 'payerEmail' },
    { name: t('address', { ns: 'fields' }), val: 'payerAddress' },
  ];

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Title subTitle text={t('billingInfo', { ns: 'sectionTitles' })} />
        {billingInfo && (
          <StyledButton
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={toggleModal}
          >
            {t('updateBillingInfo', { ns: 'buttons' })}
          </StyledButton>
        )}
      </Box>
      {billingInfo ? (
        <Box aria-label="billing-info-section">
          <TableContainer>
            <Table size="small">
              <TableBody>
                {keyValuePairs.map((pair, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <Text body text={pair.name} />
                    </TableCell>
                    <TableCell>{billingInfo?.[pair.val]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <NoContent
          title={sentenceCase(
            t('empty', {
              ns: 'descriptions',
              text: t('billingInfo', { ns: 'sectionTitles' }),
            })
          )}
          button={
            <Button onClick={toggleModal}>
              {t('add', {
                ns: 'buttons',
                text: t('billingInfo', { ns: 'sectionTitles' }),
              })}
            </Button>
          }
        />
      )}
      <BillingInfoModal
        billingData={billingInfo}
        visible={modal}
        handleClose={toggleModal}
        handleConfirm={handleConfirm}
      />
    </>
  );
};

BillingInfo.propTypes = {
  billingInfo: PropTypes.object,
  handleConfirm: PropTypes.func.isRequired,
};

export default BillingInfo;
